export const GRADE_1 = 1;
export const GRADE_2 = 2;
export const GRADE_3 = 3;
export const grade2StartDate = new Date(2021, 8, 1); // 1st September 2021
// export const grade3StartDate = new Date(2023, 8, 1); // 1st September 2023;
